// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path fill=\"currentColor\" d=\"M12 3a9 9 0 100 18 9 9 0 000-18zm-1.286 12.214a1.286 1.286 0 01-2.571 0V8.786a1.286 1.286 0 112.571 0v6.428zm5.143 0a1.286 1.286 0 11-2.571 0V8.786a1.286 1.286 0 012.571 0v6.428z\"/></svg>";
// Exports
module.exports = code;